
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AuthService } from './auth.service';
import { firstValueFrom } from 'rxjs';
import firebase from 'firebase/compat/app';

@Injectable({
  providedIn: 'root'
})
export class ModalConnector {
    private uid: string = '';
    constructor(private afs: AngularFirestore, private authSrv: AuthService){}

    private getCurrentUid(): string {
        const uid = this.authSrv.userAuth.getValue()?.uid || firebase.auth().currentUser?.uid || this.uid;
        if (!uid) {
            throw new Error('Authenticated user uid is not available');
        }
        this.uid = uid;
        return uid;
    }

    async saveCurrentData(data:any,step?:number,stage?:number, stepsPercentage:any = null){
        const uid = this.getCurrentUid();
        const insert = {userdata:data,step:step,stage:stage} as any
        if(stepsPercentage)
            insert.stepsPercentage = stepsPercentage;
        await this.afs.collection('pre-registerdata').doc(uid).set(insert,{merge:true});
    }

    async getRegisterUserData(){
        const uid = this.getCurrentUid();
        const data = await this.afs.collection('pre-registerdata').doc(uid).get();
        return await firstValueFrom(data);
    }

    getUserUid(){
        return this.getCurrentUid();
    }

    async getUserData(){
    const uid = this.getCurrentUid();
    const result = await this.afs.collection('users').doc(uid).get();
    const userData: any  = (await firstValueFrom(result)).data();
    return userData;
    }

    async isAuth(){
        this.authSrv.isLoggedIn().then(async (logged: boolean) => {
        return logged;
    });
    }
}
